function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 77.9h-35.2V49.8h-28.5v28.1h-35.2v28.5h35.2v28.1h28.5v-28.1h35.2V77.9zm-132.8 78.3c12.5-12.2 19.5-29.3 19.5-49.9 0-43-30.6-70.9-78-70.9s-78 27.8-78 70.9c0 20.6 7 37.7 19.5 49.9-11.8 3.2-23.2 8-33.8 14.2v113.1h233.9v-25.8c.1-50.6-30.6-86.7-83.1-101.5zM92.2 63.8c43.2 0 49.6 26.6 49.6 42.5s-6.4 42.5-49.6 42.5-49.6-26.6-49.6-42.5S49 63.8 92.2 63.8zM28.5 255.1V188c17.6-7.1 39.2-10.8 63.7-10.8 33.9 0 62.4 7.1 82.3 20.5 20 13.4 30.4 32.7 31.1 57.5l-177.1-.1z"
})));